import { render, staticRenderFns } from "./MaidTranList.vue?vue&type=template&id=462e0580&"
import script from "./MaidTranList.vue?vue&type=script&lang=js&"
export * from "./MaidTranList.vue?vue&type=script&lang=js&"
import style0 from "./MaidTranList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidTranList.vue"
export default component.exports